module.exports = __webpack_public_path__ + "media/images/lb/194-934c855b1e7409736a855cad92b06a17.svg";